import PropTypes from 'prop-types';
import { Link } from 'components/UI/Link/Link';
import { Button } from 'components/UI/Button/Button';
import './EventFilterModalControls.scss';

export const EventFilterModalControls = (props) => {
  const {
    eventFilters,
    closeModalHandler,
    clearAllFiltersHandler,
    applyFiltersButtonDisabled,
    applyFiltersButtonHandler,
  } = props;

  return (
    <div className="search-modal__controls" data-testid="search-modal-controls">
      <Link
        href="#"
        onClick={closeModalHandler}
        variant="secondary"
        extendClass="link-close hidden-md hidden-lg"
      >
        Close
      </Link>
      {eventFilters.length ? (
        <Link
          href="#"
          onClick={clearAllFiltersHandler}
          variant="secondary"
          extendClass="reset-filters"
        >
          Clear all filters
        </Link>
      ) : null}

      <Button
        disabled={applyFiltersButtonDisabled}
        text="Apply filters"
        variant="primary"
        extendClass="btn-apply-filters"
        onClick={applyFiltersButtonHandler}
      />
    </div>
  );
};

EventFilterModalControls.propTypes = {
  eventFilters: PropTypes.array,
  closeModalHandler: PropTypes.func,
  clearAllFiltersHandler: PropTypes.func,
  applyFiltersButtonDisabled: PropTypes.bool,
  applyFiltersButtonHandler: PropTypes.func,
};
